import { Alert, Box, Button, Stack, TextField } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import * as React from 'react';
import useModalContext from 'v2/components/Modal/useModalContext';
import useSnackbarContext from 'v2/components/Snackbar/useSnackbarContext';
import useWizardStepContext from 'v2/components/WizardModal/useWizardStepContext';

const STEP_INDEX = 2;

interface Props {
  apiKey: string | null;
}

const FinishStep: React.FC<Props> = ({ apiKey }) => {
  const { translation } = useTranslation();
  const { closeModal } = useModalContext();
  const { showSnackbar } = useSnackbarContext();
  const { setFooterContent, steps } = useWizardStepContext();

  const handleCopy = () => {
    if (apiKey) {
      navigator.clipboard.writeText(apiKey).then(
        () => showSnackbar(translation.copied_key_to_clipboard, { severity: 'success' }),
        () => showSnackbar(translation.copy_key_error, { severity: 'error' })
      );
    }
  };

  React.useLayoutEffect(() => {
    setFooterContent(
      STEP_INDEX,
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column-reverse', md: 'row' }, gap: 2 }}>
        <Button key="finish-step-close" id="finish-button" variant="contained" onClick={closeModal}>
          {translation.finish}
        </Button>
      </Box>
    );
  }, [closeModal, setFooterContent, steps, translation]);

  return (
    <Stack spacing={2}>
      <TextField
        id="input-api-key"
        value={apiKey ?? ''}
        label={translation.api_key}
        slotProps={{ input: { readOnly: true } }}
        fullWidth
      />
      <Button id="copy-key-button" variant="outlined" fullWidth onClick={handleCopy}>
        {translation.copy_key_to_clipboard}
      </Button>
      <Alert severity="info">{translation.api_key_unrecoverable_warning}</Alert>
    </Stack>
  );
};

export default FinishStep;
